import { render, staticRenderFns } from "./ManageAcks.vue?vue&type=template&id=453cbd9b&scoped=true"
import script from "./ManageAcks.vue?vue&type=script&lang=js"
export * from "./ManageAcks.vue?vue&type=script&lang=js"
import style0 from "./ManageAcks.vue?vue&type=style&index=0&id=453cbd9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453cbd9b",
  null
  
)

export default component.exports